import contacts from 'src/i18n/en/fields/contacts';
import invoices from 'src/i18n/en/fields/invoices';
import contact_groups from 'src/i18n/en/fields/contact_groups';
import payments from 'src/i18n/en/fields/payments';
import fundraising from 'src/i18n/en/fields/fundraising';
import events_transactions from 'src/i18n/en/fields/fundraisingTransaction';
import events from 'src/i18n/en/fields/events';
import tax_receipts from 'src/i18n/en/fields/tax_receipts';

const fields = {
  contacts,
  contact_groups,
  events,
  invoices,
  payments,
  fundraising,
  events_transactions,
  tax_receipts,
};

export default fields;
